import { styled } from "@mui/material";
import { chipName } from "../classes.js";
const baseSize = 20;
const ChipIcon = styled("div", {
  name: chipName,
  slot: "ChipIcon",
  overridesResolver: (_props, styles) => [styles.chipIcon]
})(() => {
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: `${baseSize}px`,
    color: "inherit",
    "& > *": {
      fontSize: "inherit"
    }
  };
});
export {
  ChipIcon
};
//# sourceMappingURL=ChipIcon.js.map
